import React from 'react'

import { fields } from './constants'
import { useMailgunEventContext } from './Context'
import { DataTool } from '../../DataTool'

export const MailgunEventDataTool = (props) => {
  const { mailgunEventListResult, filterCategory } = useMailgunEventContext()

  return (
    <DataTool
      filterCategory={filterCategory}
      fieldsConfig={fields}
      searchPlaceHolder={'Search email logs'}
      {...mailgunEventListResult}
      {...props}
      onSort={null}
    />
  )
}
